import pageTitle from 'ember-page-title/helpers/page-title';

export default pageTitle;
